module.exports = __webpack_public_path__ + "img/new_customer_status.cefc8780.svg";